import { dtpPath, useDtpParams } from '../../lib/clinicSite';
import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { useDtpAuthStore } from '../../store/useDtpAuthStore';

export function DtpProtectedRoute({ children }: { children: React.ReactNode }) {
  const { physicianId } = useDtpParams();
  const { isAuthenticated } = useDtpAuthStore();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  // A `?pi=` handoff from the clinic portal is exchanged for a session by a
  // hook in DtpLayout, which is asynchronous. This guard renders in the same
  // pass, so without waiting it redirects to the storefront before the session
  // it was about to receive ever arrives — the page just bounces.
  //
  // The hook clears the parameter whether the exchange succeeds or fails, so
  // this resolves either into the authenticated branch below or into the
  // ordinary redirect.
  if (!isAuthenticated && searchParams.get('pi')) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center text-sm text-gray-500">
        Opening the patient portal...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={dtpPath(physicianId, '/checkout?intent=portal')} state={{ patientReturnTo: location.pathname + location.search }} replace />;
  }

  return <>{children}</>;
}
